<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">

<template v-if='$store.state.auth.user.userroles[0].name=="brand"'>
  <ContentHeader :title="$route.meta.title"  url="CreateBrand" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>
</template>
<template v-else>
 <ContentHeader :title="$route.meta.title"  url="CreateBrand" :show_button="true" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader> 
</template>


<div class="content_card_content">


<!--
<ContentTable :data="data" :columns="columns" routename="Verification" deleteobjectname="verification" @dataDeleted="getData"></ContentTable>-->


<SortableTable :data="data" :columns="columns" routename="AuditorAudit" deleteobjectname="verification" @dataDeleted="getData"></SortableTable>


</div>





</div>







</div>
</template>

<script>
export default {

  name: 'AuditorVerifications',

  data () {
    return {
    	data:[],
      columns:[
      {
        type:"text",
        field:"name",
        header:"tedarikci",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"brand_name",
        header:"marka",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"project_name",
        header:"proje",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"flow_name",
        header:"akis",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"auditor_name",
        header:"denetci",
        hide_on_mobile:false,
      },
      {
        type:"pill",
        field:"status",
        header:"durum",
        selectors:["awaiting_schedule","scheduled","finished","rescheduled","canceled","under_review","on_planning"],
        options:[
          {
            name:"awaiting_schedule",
            color:"#352f8d",
            text:"planlama_bekliyor",
          },
          {
            name:"scheduled",
            color:"#7e2f8d",
            text:"planlandi",
          },
          {
            name:"finished",
            color:"#4dc247",
            text:"tamamlandi0",
          },
          {
            name:"exempt",
            color:"#0e8174",
            text:"muaf",
          },
          {
            name:"under_review",
            color:"#0e8174",
            text:"degerlendirmede",
          },
          {
            name:"rescheduled",
            color:"#ff6600",
            text:"tekrar_planlandi",
          },
          {
            name:"canceled",
            color:"#a82400",
            text:"iptal_edildi",
          },
          {
            name:"started",
            color:"#dd4b39",
            text:"baslandi",
          },
          {
            name:"on_planning",
            color:"#3b82f6",
            text:"planlamada",
          },
          {
            name:"on_technical_audit",
            color:"#3b82f6",
            text:"teknik_denetlemede",
          },
        ],
      }, 
      {
        type:"date",
        field:"scheduled_at",
        header:"oturum_tarihi",
        hide_on_mobile:true,
      },
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },

      ]
    }
  },
  mounted()
  {
    console.log(this.$store.state.auth.user)
  	this.getData()
  },
  methods:{
  	async getData()
  	{
      let data
      data = await this.generalApiGet("audit_schedules/auditor/all") 
      await console.log(data)
      let list = []
      for(let item of data)
      {
        if(item.flowsupplier)
        {
           item.name = item.supplier.name
          item.brand_name = item.flowsupplier.flow.brand.name
          item.project_name = item.flowsupplier.flow.project.name
          item.flow_name = item.flowsupplier.flow.name

          if(item.auditor)
          {
            item.auditor_name = item.auditor.user.name
          }
          list.push(item)

        }
       
        
      }

      this.data = await list
      console.log(this.data) 		
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>